export function getCheapestUpgrade() {
    let allVisible = $('[data-min_x]:visible');
    let firstVisible = -1;
    $(allVisible).each(function (e) {    
        if (firstVisible != 0 || firstVisible == -1 ) {
            if (firstVisible > $(this).children('.price').data(`price`) || firstVisible == -1 || $(this).children('.price').data(`price`) == 0) {
                firstVisible = $(this).children('.price').data(`price`);
            }
        }
    });
    return firstVisible;
}
export function changePrices() {
    let firstPrice = Number(getCheapestUpgrade());
    $('[data-min_x]:visible').each(function (index) {
        let currentPrice = Number($(this).children(`.price`).data(`price`));
        $(this).find(`span.price`).html(price(currentPrice, firstPrice));
    });
}

function price(currentPrice, firstPrice) {
    const basicPrice = Number($(`#basicprice`).text());
    let priceString = '';
    if (firstPrice <= 1) {
        firstPrice = firstPrice * basicPrice;
    }
    if (currentPrice <= 1) {
        currentPrice = currentPrice * basicPrice;
    }
    let price = (currentPrice - firstPrice) / 100;

    if (price == 0) {
        priceString = '';
    } else {
        price = parseFloat(price).toFixed(2);
        price = price.split('.');
        priceString = ` + &euro; ${price[0]},<span class="price">${price[1]}</span>`;
    }
    return priceString;
}